import React, { useMemo } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { json, jsonParseLinter } from '@codemirror/lang-json';
import { linter, lintGutter } from '@codemirror/lint';
import { autocompletion } from '@codemirror/autocomplete';
import { EditorView } from '@codemirror/view';

const documentKeys = (doc) => [
  ...new Set([...doc.matchAll(/"([\w-]+)"\s*:/g)].map((match) => match[1])),
];

/* eslint-disable react/destructuring-assignment */
const completionSource = (context) => {
  const quoted = context.matchBefore(/"[\w-]*/);
  const bare = context.matchBefore(/[\w-]+/);
  const match = quoted ?? bare;
  if (!match || (match.from === match.to && !context.explicit)) return null;
  const isQuoted = Boolean(quoted);
  const typed = match.text.replace(/^"/, '');
  const keys = documentKeys(context.state.doc.toString())
    .filter((key) => key !== typed)
    .sort();
  if (keys.length === 0) return null;
  return {
    from: match.from,
    options: keys.map((key) => ({
      label: isQuoted ? `"${key}"` : key,
      type: 'property',
      detail: 'key',
    })),
    validFor: /^"?[\w-]*$/,
  };
};
/* eslint-enable react/destructuring-assignment */

const JsonCodeEditor = ({ value, onChange, readOnly, hasError }) => {
  const extensions = useMemo(
    () => [
      json(),
      linter(jsonParseLinter()),
      lintGutter(),
      autocompletion({ override: [completionSource] }),
      EditorView.lineWrapping,
    ],
    [],
  );

  return (
    <div
      className={`json-code-editor${hasError ? ' json-code-editor-error' : ''}`}
    >
      <CodeMirror
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        basicSetup={{
          lineNumbers: true,
          foldGutter: true,
          highlightActiveLine: true,
          highlightActiveLineGutter: true,
          bracketMatching: true,
          closeBrackets: true,
          autocompletion: false,
        }}
        extensions={extensions}
      />
    </div>
  );
};

export default JsonCodeEditor;
